import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const PrizeWrapper = styled.div`
    margin: 5px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;
`;

export const PrizeBottom = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
`;

export const PrizeDetails = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
`;

export const PrizeContent = styled.div<{ $compact?: boolean }>`
    width: 100%;
    border-radius: 5px;
    background: ${({ theme }) => theme.shades.white[5]};
    padding: ${({ $compact }) => ($compact ? '8px' : '8px 12px;')};
    margin: 0 6px 0 0;
`;
export const PrizeContentLink = styled.a<{ $compact?: boolean }>`
    ${styledReset.link};
    width: ${({ $compact }) => ($compact ? 'clamp(100px, 100%, 280px)' : 'clamp(200px, 100%, 400px)')};
`;

export const PrizeImg = styled.img`
    max-height: 30px;
    width: 30px;
    border-radius: 5px;
`;
